<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">KD ’000</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">Profit for the year</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">185,150</td>
                            <td class="end font">216,928</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">Shares</td>
                            <td class="end font white font-weight-bold">Shares</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">Weighted average number of shares in issue</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">4,327,058,909</td>
                            <td class="end font">4,327,058,909</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">Fils</td>
                            <td class="end font white font-weight-bold">Fils</td>
                        </tr>
                        <tr>
                            <td class="font blackColor" colspan="3">Basic and diluted earnings per share</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">43</td>
                            <td class="end font">50</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td colspan="2" class="center white bolder">ألف دينار كويتي</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="font" colspan="3">ربح السنة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">185,150</td>
                            <td class="end font">216,928</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">سهم</td>
                            <td class="end font white font-weight-bold">سهم</td>
                        </tr>
                        <tr>
                            <td class="font" colspan="3">المتوسط المرجح لعدد الأسهم المصدرة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">4,327,058,909</td>
                            <td class="end font">4,327,058,909</td>
                        </tr>
                        <tr class="dark-gray">
                            <td class="font" colspan="3"><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font white font-weight-bold">فلس</td>
                            <td class="end font white font-weight-bold">فلس</td>
                        </tr>
                        <tr>
                            <td class="font blackColor" colspan="3">ربحية السهم الأساسية والمخففة</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="end font ligest-gray">43</td>
                            <td class="end font">50</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>